import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { SearchParams } from '../../../../../../shared/search/models/search-params.model';
import { SearchStatus } from '../../../../../../shared/search/models/search-status.model';
import { SearchService } from '../../../../../../shared/search/search.service';
import { AlertService } from 'sce-core';
import { SearchEvent } from '../../../../../../shared/search/models/search-event';
import { ResourceService } from 'sce-core';
import { CoreServiceRegistry } from '../../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../../shared/shared-service-registry';
import { DataTableConfig } from '../../../../../../shared/search/models/data-table-config';
import { NEW_ROW_EVENT, AUTO_ADD_ROW_EVENT } from '../../../../../../shared/search/search-constants';
import { CommodityDataService } from '../../service/commodity-data.service';
import { CommodityButtonService } from '../../service/commodity-button.service';
import { ButtonItem } from '../../../../../../shared/button/button.model';
import { ConfirmDialogService } from 'sce-core';
import { ViewLocationDataEditorService } from './view-location-popup-data-editor.service';
import { ModalService } from '../../../../../../shared/services/modal.service';

@Component({
  selector: 'lfwms-view-location-popup',
  templateUrl: './view-location-popup.component.html',
  styleUrls: ['./view-location-popup.component.css'],
})
export class ViewLocationLookupComponent implements OnInit {

  public lookupAlertService: AlertService;
  public confirmDialogService: ConfirmDialogService;
  public resourceService: ResourceService;
  public title: string;
  public currentPage: number = 1;
  public selectedTab: any;
  public primaryDataMapCopy: any;
  public metaData: any;

  public searchService: SearchService;

  public expandSearchAccordion: boolean = true;
  public eventSubject = new Subject<any>();
  public dataEditor: any;
  private buttons;
  public dataService: CommodityDataService;
  public buttonService: CommodityButtonService;
  public tableMode: string = 'V';
  public errorMsg: string;
  protected http$: HttpClient;

  // newly added variables
  public eventVariable: any;

  constructor(public modalService: ModalService,
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry) {
    this.lookupAlertService = new AlertService();
    this.confirmDialogService = new ConfirmDialogService();
    this.eventSubject = new Subject<any>();
    this.http$ = coreServiceRegistry.http$;
    this.resourceService = this.coreServiceRegistry.resourceService;
     this.dataEditor = new ViewLocationDataEditorService(coreServiceRegistry, sharedServiceRegistry);
    this.buttons = [
      new ButtonItem('Edit', this.resourceService.get('btn_edit'), 'sku_assgn_loc_edit', 'user-plus-circle', []),
      new ButtonItem('Add Row', this.resourceService.get('lbl_AddNewRow'), 'sku_assgn_loc_create', 'user-plus-circle', []),
      new ButtonItem('Save', this.resourceService.get('btn_save'), '', 'floppy-disk', []),
      new ButtonItem('Delete', this.resourceService.get('btn_delete'), 'sku_assgn_loc_delete', 'trash', []),
    ];
  }
  public ngOnInit() {
    this.refreshButtons();
  }

  public initializeComponents(dataService, primaryDataMap) {
    this.dataService  = dataService;
    this.dataService.dataEditor = this.dataEditor;
    this.dataEditor.dataService = dataService;
    this.primaryDataMapCopy = primaryDataMap;
    this.initializeSearchServices();
  }

  private initializeSearchServices() {
    this.createSearchService('ASSIGNLOCTD');
  }


  private createSearchService(tableId: string): SearchService {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    searchParams.defaultSearchColumn = '';
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    tableConfig.editable = true;
    tableConfig.isColumnEditable = this.isColumnEditable;
    searchParams.dataTableConfig = tableConfig;
    searchParams.alertService = this.lookupAlertService;
    searchParams.tableEditor = this.dataEditor;
    searchParams.actionButtons = this.buttons;

    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    this.searchService = searchService;
    this.searchService.searchParams = searchParams;
    this.searchService.searchParams.tableId = 'ASSIGNLOCTD';
    tableConfig.showIdAsAHyperLink = true;
    searchParams.idProperty = 'storerKey';

    this.dataEditor.searchService = searchService;
    this.dataEditor.searchParams = searchParams;
    this.dataEditor.tableConfig = tableConfig;
    this.searchService.fetchMetadata().subscribe((metadata: any) => {
      this.metaData = metadata;
      this.createSearchCriteria();
      this.searchService.searchParams.tableId = 'ASSIGNLOCTD';
      this.searchService.searchParams.isFullFetch = true;
      this.searchService.performSearch();
      this.searchService.searchStatus.hasResults = true;
    });
    searchService.receiveEvent().subscribe((event: SearchEvent) => {
      if (this.searchService.getPagedData().aggridApi) {
        this.dataService.searchService = this.searchService;
      }
      if (event.type === NEW_ROW_EVENT) {
        this.eventVariable = event;
      }
    });
    return searchService;
  }

  /**
  * If the table is in View Mode make all columns as non editable
  * In the Edit Mode, make columns editable based on its metadata
  * In Create Mode, make all columns as editable
  * @paramdisplayType : The column displayType as in metadata
  */
 private isColumnEditable(params: any) {
  const rowData = params.data;
  const componentRef = params.context.componentParent;
  // if the table is in view mode, do not make any column as editable
  if (['V', 'P'].indexOf(componentRef.tableMode) !== -1) {
    return false;
  }

  const isNewRow: boolean = rowData && rowData['isNewItem'] && rowData['isNewItem'].cVal;
  if (isNewRow && componentRef.metaDataMap[params.colDef.colId].displayType === 'EL') {
    return true;
  } else if (componentRef.metaDataMap[params.colDef.colId].displayType === 'EL') {
    return false;
  } else {
    // enable the column only if it is an editable field in the metadata
    return (['E', 'L', 'EA'].indexOf(componentRef.metaDataMap[params.colDef.colId].displayType) > -1);
  }
}


  public createSearchCriteria() {
    this.searchService.setSearchCriteria({
      conditions: [{
        mandatory: false,
        clauses: [{
          column: 'sku',
          operation: '=',
          value: this.primaryDataMapCopy['sku'].cVal,
          logicalOperation: null
        },
        {
          column: 'storerKey',
          operation: '=',
          value: this.primaryDataMapCopy['storerKey'].cVal,
          logicalOperation: 'AND'
        }],
        logicalOperation: null
      }]
    });
    this.searchService.setSearchCriteria({
      conditions: [{
        mandatory: false,
        clauses: [{
          column: 'sku',
          operation: '=',
          value: this.primaryDataMapCopy['sku'].cVal,
          logicalOperation: null
        },
        {
          column: 'storerKey',
          operation: '=',
          value: this.primaryDataMapCopy['storerKey'].cVal,
          logicalOperation: 'AND'
        }],
        logicalOperation: null
      }]
    });
  }

  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

private refreshButtons() {
  this.buttons.forEach((button: ButtonItem) => {
    switch (button.action) {
      case 'Edit' :  {
        button.isEnabled = (this.tableMode === 'V');
        button.isVisible =  (this.tableMode === 'V');
        break;
      }
      case 'Save' :  {
        button.isEnabled = (this.tableMode === 'E');
        button.isVisible =  (this.tableMode === 'E');
        break;
      }
      case 'Add Row' :  {
        button.isEnabled = (this.tableMode === 'E');
        button.isVisible =  (this.tableMode === 'E');
        break;
      }
      case 'Delete' :  {
        button.isEnabled = (this.tableMode === 'E');
        button.isVisible =  (this.tableMode === 'E');
        break;
      }
    }
  });
}


  public handleButtonAction(action: string) {
    if (action === 'Add Row') {
      this.tableMode = 'E';
      const evt = new SearchEvent(AUTO_ADD_ROW_EVENT);
      this.searchService.publishEvent(evt);
    }
    if (action === 'Edit') {
      this.tableMode = 'E';
      this.refreshButtons();
    }
    if (action === 'Save') {
      this.save();
    }
    if (action === 'Delete') {
      this.deleteLineItem();
    }

  }

  public save() {
    const pagedRows = this.searchService.getEditedRows();
    const allRows = this.searchService.getAllRows();
    if (allRows.length === 0) {
      this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_detail'));
      return;
    }
    if (pagedRows.length === 0) {
      this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_mod'));
      return;
    }
    const finalSaveData: Array<any> = [];
    let erroOccurred: boolean = false;

    pagedRows.forEach((row: any) => {
      const rowData = [];
      const rowDataArray: any = row['cells'];
      if (row['isNewRow']) {
        Object.keys(rowDataArray).forEach((element: any) => {
          if (rowDataArray[element] &&  (element !== 'isNewItem') && (element !== 'sku')) {
            if ((rowDataArray[element].cName === 'loc') && !(rowDataArray[element].cVal)) {
              this.errorMsg = 'err_msg_val_loc';
              erroOccurred = true;
              return;
            }
            const newElements: any = {
              'cName': element,
              'cVal': rowDataArray[element].cVal
            };
            rowData.push(newElements);
          }else if (element === 'sku') {
            const newElementsku: any = {
              'cName': 'sku',
              'cVal': this.primaryDataMapCopy['sku'].cVal
            };
            rowData.push(newElementsku);
          } else {
            const newRowFlag: any = {
              'cName': 'isNewItem',
              'cVal': rowDataArray[element].cVal
            };
            rowData.push(newRowFlag);
          }
        });
        finalSaveData.push({
          'moduleProperties': rowData,
          'screenType': this.searchService.searchParams.tableId,
          'detailItems': []
        });
      } else {
        Object.keys(rowDataArray).forEach((element: any) => {
          if ((rowDataArray[element].cName === 'loc') && !(rowDataArray[element].cVal)) {
            this.errorMsg = 'err_msg_val_loc';
            erroOccurred = true;
            return;
          }
          const oldValue: any = {
            'cName': 'original_' + rowDataArray[element].cName,
            'cVal': rowDataArray[element].cValOrig
          };
          const newValue: any = {
            'cName': rowDataArray[element].cName,
            'cVal': rowDataArray[element].cVal
          };
          rowData.push(oldValue);
          rowData.push(newValue);
        });
        finalSaveData.push({
          'moduleProperties': rowData,
          'screenType': this.searchService.searchParams.tableId,
          'detailItems': []
        });
      }
    });
    const sucessMessage: string = 'msg_save_succ';
    if (erroOccurred) {
      this.lookupAlertService.error(this.resourceService.get(this.errorMsg));
      this.tableMode = 'E';
      return;
    }
    this.saveDataForPopUp(finalSaveData)
          .subscribe((resp: any) => {
            if (resp['statusCode'] !== undefined && resp['statusCode'] !== null) {
              if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
                // code to reload the  detail grid
                this.lookupAlertService.clearAll();
                this.lookupAlertService.success(this.resourceService.get(sucessMessage));
                this.coreServiceRegistry.navigationService.preventNavigation = false;
                this.tableMode = 'V';
                this.refreshButtons();
                this.searchService.performSearch();
              } else {
                this.lookupAlertService.clearAll();
                this.lookupAlertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
              }
            } else {
              if (resp.error) {
                this.lookupAlertService.clearAll();
                this.lookupAlertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
              }
            }
          }, (error) => {
            this.lookupAlertService.clearAll().error(this.resourceService.translateServerResponse(error));
          });
  }


  public saveDataForPopUp(request) {
    const response$ = this.http$.put(`api/setup/`, JSON.stringify(request))
    .map((response: any) => {
      if (response['errors']) {
        if (response['errors'][0].validationCode !== 200) {
          return Observable.throw(response['errors'][0].validationMessage);
        }
      } else {
        return response;
      }
    }).catch((error: any) => {
      if (error.error.length !== 0) {
        if (error.error.statusCode && error.error.statusCode !== 200) {
          return Observable.throw(error.error.statusMessage);
        } else if (error.status === 400) {
          return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
        }
      }
    });
  return response$;
  }

  public deleteLineItem() {
    const sucessMessage: string = 'msg_del_succ';
    const noOfLineItems = this.searchService.getPagedData().pageDefinition.recordCount;
    const selectedRows = this.searchService.getSelectedRows();
    if (noOfLineItems === 0) {
      this.errorMsg = 'msg_no_detail';
      this.lookupAlertService.clearAll().error(this.resourceService.get(this.errorMsg));
      return;
    }
    if (selectedRows.length > 0) {
      const selectedRow = this.searchService.getSelectedRows();
      const finalDeleteData: Array<any> = [];

      selectedRow.forEach((row: any) => {
        const rowData = [];
        let rowDataArray: Array<any> = [];
        rowDataArray = row['cells'];
        Object.keys(rowDataArray).forEach((element: any) => {
          const item: any = {
            'cName': rowDataArray[element].cName,
            'cVal': rowDataArray[element].cVal
          };
          rowData.push(item);
        });

        finalDeleteData.push({
          'moduleProperties': rowData,
          'screenType': this.searchService.searchParams.tableId,
        });
      });
      if (finalDeleteData.length > 0) {
        this.deleteSelectedLineItemFromAdvConfig(finalDeleteData)
          .subscribe((resp: any) => {
            if (resp['statusCode'] !== undefined && resp['statusCode'] !== null) {
              if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
                // code to reload the  detail grid
                this.lookupAlertService.clearAll();
                this.lookupAlertService.success(this.resourceService.get(sucessMessage));
                this.searchService.performSearch();
              } else {
                this.lookupAlertService.clearAll();
                this.lookupAlertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
              }
            } else {
              if (resp.error) {
                this.lookupAlertService.clearAll();
                this.lookupAlertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
              }
            }
          }, (error) => {
            this.lookupAlertService.clearAll().error(this.resourceService.translateServerResponse(error));
          });
      }
    } else {
      this.lookupAlertService.clearAll();
      this.lookupAlertService.error(this.resourceService.get(this.errorMsg));
    }
  }

  public deleteSelectedLineItemFromAdvConfig(request: any): Observable<Response> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }





}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/setup/customer/commodity/commodity-home/popup/view-location-popup.component.ts